/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var loadingButtons = new Set();

  function getMiniCart() {
    return document.getElementById('mini-cart');
  }

  function getMiniCartToggle() {
    return document.querySelector('[aria-controls="mini-cart"][data-action="toggle-mini-cart"]');
  }

  function setButtonLoading(button) {
    if (!button) {
      return;
    }

    loadingButtons.add(button);
    button.classList.add('is-adding-to-cart');
    button.setAttribute('aria-busy', 'true');
  }

  function clearButtonLoading(button) {
    if (!button) {
      return;
    }

    button.classList.remove('is-adding-to-cart');
    button.removeAttribute('aria-busy');
    loadingButtons.delete(button);
  }

  function clearAllLoadingButtons() {
    loadingButtons.forEach(clearButtonLoading);
  }

  function setMiniCartRefreshing(isRefreshing) {
    var miniCart = getMiniCart();

    if (!miniCart) {
      return;
    }

    miniCart.classList.toggle('mini-cart--refreshing', isRefreshing);
  }

  function openMiniCart() {
    var toggle = getMiniCartToggle();

    if (!toggle || toggle.getAttribute('aria-expanded') === 'true') {
      return;
    }

    toggle.click();
  }

  function updateVisibleCartCount(quantity) {
    var countElement = document.querySelector('.header__cart-count');
    var quantityToAdd = parseInt(quantity, 10);

    if (!countElement || Number.isNaN(quantityToAdd)) {
      return;
    }

    var currentCount = parseInt(countElement.textContent, 10);

    if (Number.isNaN(currentCount)) {
      currentCount = 0;
    }

    countElement.textContent = currentCount + quantityToAdd;
  }

  document.addEventListener('click', function (event) {
    var buyButton = event.target.closest('buy-button');

    if (!buyButton) {
      return;
    }

    var button = event.target.closest('button[type="submit"]');
    var form = event.target.closest('form[action*="/cart/add"]');

    if (!button || !form || button.disabled) {
      return;
    }

    setButtonLoading(button);
  }, true);

  document.addEventListener('product:added', function (event) {
    if (event.detail && event.detail.productAdded && window.theme && window.theme.pageType !== 'cart' && window.theme.cartType === 'drawer') {
      updateVisibleCartCount(event.detail.quantity);
      openMiniCart();
      setMiniCartRefreshing(true);
    }
  }, true);

  document.addEventListener('product:added', function (event) {
    var button = event.detail && event.detail.button ? event.detail.button.closest('button') : null;

    if (button) {
      clearButtonLoading(button);
      return;
    }

    clearAllLoadingButtons();
  });

  document.addEventListener('theme:loading:end', function () {
    clearAllLoadingButtons();
    setMiniCartRefreshing(false);
  });

  // Intercept BoostAI ATC button clicks before BoostAI's own handler runs
  // (capture phase = runs first). We do the cart fetch ourselves and fire
  // product:added so the drawer opens, preventing BoostAI's /cart redirect.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-metadata]');
    if (!btn || btn.disabled) return;

    var metadata;
    try { metadata = JSON.parse(btn.getAttribute('data-metadata')); } catch (e) { return; }

    var atcAction = metadata && metadata.action && metadata.action.addToCart;
    if (!atcAction) return;

    event.stopImmediatePropagation();

    var body = { id: atcAction.productId, quantity: 1 };
    if (atcAction.selling_plan) body.selling_plan = atcAction.selling_plan;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { productAdded: true, quantity: 1 }
        }));
      }
    });
  }, true);
})();

(function () {
  // Boost AI Search & Discovery: drive sections/product-recommendations.liquid
  // ("Related products") from Boost's Recommendation API instead of Shopify's
  // own algorithm, without touching that section's markup, styles, or its
  // carousel behaviour (ProductRecommendationsSection in theme.js).
  //
  // theme.js fetches `routes.productRecommendationsUrl?section_id=...&product_id=...`
  // and swaps the response straight into the section. We intercept that one
  // call: fetch Boost's recommended product ids, then resolve it through
  // Shopify's Section Rendering API using the same "id:x OR id:y" search
  // trick sections/recently-viewed-products.liquid already relies on, so the
  // section still receives real server-rendered product-item markup.
  //
  // This has to install before theme.js runs (hence custom.js now loads
  // first in layout/theme.liquid), since the native fetch fires synchronously
  // when the section is constructed.
  var nativeFetch = window.fetch.bind(window);

  function getSectionSettings(sectionId) {
    var el = document.querySelector('[data-section-id="' + sectionId + '"][data-section-type="product-recommendations"]');
    if (!el) return null;
    try {
      return JSON.parse(el.getAttribute('data-section-settings'));
    } catch (e) {
      return null;
    }
  }

  // On the cart page the section passes every product in the cart
  // (settings.productIds) so Boost recommends against the whole cart, not one item.
  function fetchBoostRecommendations(settings, excludeProductId) {
    var sourceIds = settings.productIds && settings.productIds.length ? settings.productIds : [excludeProductId];
    return nativeFetch('https://services.mybcapps.com/discovery/recommend', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: settings.boostShop,
        wid: settings.boostWidgetId,
        recommendationType: settings.boostRecommendationType,
        pg: settings.boostPage || 'product_page',
        limit: settings.recommendationsCount,
        layoutDisplay: 'carousel',
        productIds: sourceIds
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Boost recommendation request failed: ' + response.status);
      return response.json();
    }).then(function (data) {
      var products = (data && data.products) || [];
      return products
        .map(function (product) { return product.id; })
        .filter(function (id) { return id && sourceIds.indexOf(id) === -1; })
        .slice(0, settings.recommendationsCount);
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isRecommendationsRequest = window.routes
      && window.routes.productRecommendationsUrl
      && url.indexOf(window.routes.productRecommendationsUrl) === 0;

    if (!isRecommendationsRequest) {
      return nativeFetch(input, init);
    }

    var params = new URLSearchParams(url.split('?')[1] || '');
    var sectionId = params.get('section_id');
    var productId = parseInt(params.get('product_id'), 10);
    var settings = sectionId ? getSectionSettings(sectionId) : null;

    if (!settings || !settings.boostWidgetId) {
      return nativeFetch(input, init);
    }

    return fetchBoostRecommendations(settings, productId)
      .then(function (ids) {
        if (!ids.length) {
          return nativeFetch(input, init);
        }

        var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');

        return nativeFetch(
          window.routes.searchUrl + '?section_id=' + encodeURIComponent(sectionId) + '&type=product&q=' + encodeURIComponent(query),
          { credentials: 'same-origin' }
        );
      })
      .catch(function (error) {
        console.warn('[Boost recommendations] falling back to native Shopify recommendations:', error);
        return nativeFetch(input, init);
      });
  };
})();

(function () {
  // Boost AI Search & Discovery: drive the cart drawer's recommendations list
  // (snippets/mini-cart.liquid, .mini-cart__recommendations-panel) from
  // Boost's Recommendation API instead of the static settings-driven
  // collection list, without changing its markup or styling. Boost's own
  // response already includes handle/title/price/images, so unlike the PDP
  // "Related products" section, no second Shopify fetch is needed here.
  //
  // The drawer's HTML can be replaced wholesale by several different native
  // flows (initial load, add-to-cart, quantity change), so instead of
  // chasing each one individually we watch the drawer with a
  // MutationObserver and re-run whenever its content changes.
  var nativeFetch = window.fetch;

  function formatMoney(amount) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return format.replace('{{amount}}', Number(amount).toFixed(2));
  }

  function buildRecommendationItem(product) {
    var image = product.images && Object.values(product.images)[0];
    var li = document.createElement('li');
    li.className = 'mini-cart__recommendation';

    var link = document.createElement('a');
    link.className = 'mini-cart__recommendation-link';
    link.href = '/products/' + product.handle;

    if (image) {
      var imageWrap = document.createElement('span');
      imageWrap.className = 'mini-cart__recommendation-image';
      var img = document.createElement('img');
      img.src = image + (image.indexOf('?') === -1 ? '?' : '&') + 'width=180';
      img.width = 82;
      img.height = 82;
      img.loading = 'lazy';
      img.alt = product.title || '';
      imageWrap.appendChild(img);
      link.appendChild(imageWrap);
    }

    var copy = document.createElement('span');
    copy.className = 'mini-cart__recommendation-copy';

    var title = document.createElement('span');
    title.className = 'mini-cart__recommendation-title';
    title.textContent = product.title;

    var price = document.createElement('span');
    price.className = 'mini-cart__recommendation-price';
    price.textContent = formatMoney(product.price_min);

    copy.appendChild(title);
    copy.appendChild(price);
    link.appendChild(copy);
    li.appendChild(link);
    return li;
  }

  function refreshDrawerRecommendations() {
    var panel = document.querySelector('.mini-cart__recommendations-panel');
    if (!panel) return;

    var widgetId = panel.getAttribute('data-boost-widget-id');
    if (!widgetId) return;

    var list = panel.querySelector('.mini-cart__recommendations-list');
    if (!list) return;

    var shop = panel.getAttribute('data-boost-shop');
    var recommendationType = panel.getAttribute('data-boost-recommendation-type') || 'frequently-bought-together';
    var count = parseInt(panel.getAttribute('data-boost-count'), 10) || 4;

    nativeFetch(window.routes.cartUrl + '.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var cartProductIds = cart.items.map(function (item) { return item.product_id; });
        var body = {
          shop: shop,
          wid: widgetId,
          recommendationType: cartProductIds.length ? recommendationType : 'bestsellers',
          pg: 'cart_page',
          limit: count,
          layoutDisplay: 'carousel'
        };
        if (cartProductIds.length) {
          body.productIds = cartProductIds;
        }

        return nativeFetch('https://services.mybcapps.com/discovery/recommend', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (response) {
          if (!response.ok) throw new Error('Boost recommendation request failed: ' + response.status);
          return response.json();
        }).then(function (data) {
          var products = ((data && data.products) || [])
            .filter(function (product) { return cartProductIds.indexOf(product.id) === -1; })
            .slice(0, count);

          if (!products.length) return;

          list.innerHTML = '';
          products.forEach(function (product) {
            list.appendChild(buildRecommendationItem(product));
          });
        });
      })
      .catch(function (error) {
        console.warn('[Boost drawer recommendations] keeping existing list:', error);
      });
  }

  var refreshTimeout = null;
  function scheduleRefresh(mutationsList) {
    var panel = document.querySelector('.mini-cart__recommendations-panel');

    // Ignore mutations caused by our own list swap above - only react when
    // something outside the recommendations panel changed (a real drawer
    // refresh), otherwise this would re-trigger itself forever.
    var isExternalChange = mutationsList.some(function (mutation) {
      return !panel || !panel.contains(mutation.target);
    });
    if (!isExternalChange) return;

    clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(refreshDrawerRecommendations, 50);
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshDrawerRecommendations();

    var miniCart = document.querySelector('.mini-cart');
    if (!miniCart) return;

    new MutationObserver(scheduleRefresh).observe(miniCart, { childList: true, subtree: true });
  });
})();


/* Per-variant vendor (custom.vendor metafield, falls back to product vendor) — map rendered by snippets/product-meta.liquid */
document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant;
  var section = event.target.closest('.shopify-section') || document;
  var mapEl = section.querySelector('[data-brand-map]');
  if (!variant || !mapEl) return;

  var entry = JSON.parse(mapEl.textContent)[variant.id];
  if (!entry) return;

  var brand = section.querySelector('.product-meta__brand');
  if (brand) {
    brand.textContent = entry.brand;
    brand.href = entry.url;
    brand.hidden = !entry.brand;
  }

  var vendor = section.querySelector('.product-meta__vendor');
  if (vendor) {
    vendor.textContent = entry.vendor;
    vendor.href = entry.url;
  }
});
